import { handleLoginFailure } from "../../Routes/authUtils";
import { SIGNIN_API } from "../constants/constants";
import { determineBaseUrlAndPerformApiCall } from "../interceptor/interceptor";
import 'react-toastify/dist/ReactToastify.css';
import { fetchsigninFailure, fetchsigninSuccess } from "./reducer";

export const signInUser = (values, navigate, setLoading) => async (dispatch) => {
  try {
    setLoading(true);
    const response = await determineBaseUrlAndPerformApiCall(`${SIGNIN_API}/${values.email}`, 'GET');
    if (response) {
      localStorage.setItem("environment", response?.rbac);
      localStorage.setItem("isSSO", response?.isSSOUser);
      localStorage.setItem("redirect_url", response?.redirectURL);
      localStorage.setItem("userEmail", values.email);
      
      dispatch(fetchsigninSuccess(response));
      
      // Handle Keycloak environment
      if (response?.rbac?.toLowerCase() === "keycloak") {        
        // Clear any existing tokens to prevent wrong user login
        localStorage.removeItem('token');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('id_token');
        localStorage.removeItem('userId');
        localStorage.removeItem('userName');
        
        localStorage.setItem("environment", "Keycloak");
        
        // Build Keycloak login URL directly
        const redirectUri = `${window.location.origin}/keycloak/callback`;
        
        // Generate PKCE parameters
        const state = generateRandomString(32);
        const nonce = generateRandomString(32);
        const codeVerifier = generateCodeVerifier();
        const codeChallenge = await generateCodeChallenge(codeVerifier);
        
        // Store in sessionStorage for validation on callback
        sessionStorage.setItem('keycloak_state', state);
        sessionStorage.setItem('keycloak_nonce', nonce);
        sessionStorage.setItem('pkce_code_verifier', codeVerifier);
        
        // Construct the login URL WITHOUT kc_idp_hint since you want to hide IdPs
        const params = new URLSearchParams({
          client_id: window.env.REACT_APP_KEYCLOAK_CLIENT_ID,
          redirect_uri: redirectUri,
          state: state,
          response_mode: 'query',
          response_type: 'code',
          scope: 'openid',
          nonce: nonce,
          code_challenge: codeChallenge,
          code_challenge_method: 'S256',
          login_hint: values.email,
          prompt: 'login', 
        });
        
        const loginUrl = `${window.env.REACT_APP_KEYCLOAK_ENV}/realms/${window.env.REACT_APP_KEYCLOAK_REALM}/protocol/openid-connect/auth?${params.toString()}`;
        window.location.href = loginUrl;
        
        return;
      } else {
        // For other environments
        setLoading(false);
        navigate(`/login/${values.email}`);
      }
    } else {
      dispatch(fetchsigninFailure(response?.error?.message));
      handleLoginFailure(response?.error?.message, setLoading);
    }
  } catch (error) {
    dispatch(fetchsigninFailure(error?.response?.data?.error?.message));
    handleLoginFailure(error?.response?.data?.error?.message, setLoading);
  }
};
function generateRandomString(length) {
  const charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';
  const randomValues = new Uint8Array(length);
  crypto.getRandomValues(randomValues);
  
  let result = '';
  for (let i = 0; i < length; i++) {
    result += charset[randomValues[i] % charset.length];
  }
  return result;
}

function generateCodeVerifier() {
  return generateRandomString(128);
}

async function generateCodeChallenge(verifier) {
  const encoder = new TextEncoder();
  const data = encoder.encode(verifier);
  const hash = await crypto.subtle.digest('SHA-256', data);
  return base64UrlEncode(hash);
}

function base64UrlEncode(arrayBuffer) {
  const bytes = new Uint8Array(arrayBuffer);
  let binary = '';
  for (let i = 0; i < bytes.length; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary)
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=/g, '');
}